import { getImageUrl } from "../../utils/functions/images";
import { ReadOnlyEditor } from "../TextEditor/ReadOnlyEditor";

export default function BulletSkeleton({ dragContent, withActionPointsIcon = true }: { dragContent: string, withActionPointsIcon?: boolean }) {
  return (
    <div
      className="p-0 flex flex-wrap sm:flex-nowrap justify-start items-center gap-y-2 sm:gap-y-0 min-w-0 border-b border-neutral-200 bg-white"
    >
      <img
        className="cursor-grabbing flex-shrink-0 w-5 h-5 sm:w-5 sm:h-5 md:w-auto md:h-auto object-contain"
        src={getImageUrl('Button')}
        alt="drag"
      />
      <div className="flex w-full min-w-0 flex-1 sm:min-w-0">
        <img src={getImageUrl('bullet')} alt="point" className="ml-2 mr-2" />
        <div className="flex-1 min-w-0 overflow-hidden py-[2px]">
          <ReadOnlyEditor content={dragContent} className="text-gray-600 !leading-6 py-2 sm:py-2.5 text-sm sm:text-base focus:outline-none min-h-[1.5rem]" />
        </div>
      </div>
      <div className="pl-2 sm:pl-3 md:pl-4 flex flex-shrink-0 items-center relative -left-0 sm:-left-2.5 md:-left-3 gap-x-1.5 sm:gap-x-2 ms-auto text-sm leading-[1.5715] md:min-h-[1.375rem]">
        <span className="inline-flex items-center gap-x-0.5 shrink-0">
          {withActionPointsIcon && (
            <span className="inline-flex items-center justify-center h-6 w-6 md:h-[1.375rem] md:w-[1.375rem] cursor-pointer">
              <img src={getImageUrl('DotsHorizontal')} alt="..." className="w-4 h-4 object-contain block" />
            </span>
          )}
          <span className="inline-flex items-center justify-center h-6 w-6 md:h-[1.375rem] md:w-[1.375rem] cursor-pointer">
            <img src={getImageUrl('Trash')} alt="Delete" className="w-4 h-4 object-contain block" />
          </span>
        </span>
      </div>
    </div>
  );
}
